
$("fieldset.js.product-form__input input").change(function(){
    setTimeout(function() {
var get_id = $("input.product-variant-id").val();
    var get_title = $(".option_custom_variant .var_title[data-id="+get_id+"] .var_title_custom").html();
            var get_desc = $(".option_custom_variant .var_description[data-id="+get_id+"]").html();
var var_features =  $(".option_custom_variant .var_features[data-id="+get_id+"]").html();
var var_specs =  $(".option_custom_variant .var_specs[data-id="+get_id+"]").html();
        
        $(".main_product_features .content").html(var_features);
      if($(".custom_var_data").hasClass('has_meta')){
            var get_title = $(".option_custom_variant .var_title[data-id="+get_id+"] .custom_var_data").html();

        $(".product__title.product-title_main_wrap").html(get_title);

     }else{
        $(".product__title.product-title_main_wrap .sub_text .var_title_custom").html(get_title);
      }
                $(".product__description.rte.quick-add-hidden").html(get_desc);
            
      $(".var_spcs_wrap").html(var_specs);
        
        }, 100);

});

$(document).ready(function(){
var get_id = $("input.product-variant-id").val();
var get_title = $(".var_title[data-id="+get_id+"] .var_title_custom").html();
 if($(".custom_var_data").hasClass('has_meta')){
            var get_title = $(".option_custom_variant .var_title[data-id="+get_id+"] .custom_var_data").html();

        $(".product__title.product-title_main_wrap").html(get_title);

     }else{
$(".product__title.product-title_main_wrap .sub_text").append('<span class="var_title_custom">'+get_title+'</span>');
 }
// Check if the body has the class 'temp-collection'
if (document.body.classList.contains('temp-collection')) {
    // Find the target div and get its innerHTML
    const targetDiv = document.querySelector('nav.breadcrumb');
    
    if (targetDiv) {
        // Store the HTML content of the div in local storage
        localStorage.setItem('breadcrumb', targetDiv.innerHTML);
    }
}
// Check if the body has the class 'temp-collection'
if (document.body.classList.contains('temp-collection')) {
    // Find the target div and get its innerHTML
    const targetDiv = document.querySelector('.breadcrumb');
    
    if (targetDiv) {
        // Store the HTML content of the div in local storage
        localStorage.setItem('breadcrumb', targetDiv.innerHTML);
        
        // Get the current page URL
        const currentUrl = window.location.href;
        
        // Select the last span element
        const spans = targetDiv.querySelectorAll('span');
        if (spans.length > 0) {
            const lastSpan = spans[spans.length - 1];
            
            // Wrap the last span in an anchor tag
            const anchor = document.createElement('a');
            anchor.href = currentUrl;
            anchor.appendChild(lastSpan.cloneNode(true));
            lastSpan.replaceWith(anchor);
            
            // Update local storage with the modified HTML
            localStorage.setItem('breadcrumb', targetDiv.innerHTML);
        }
    }
} else {
    // If the class doesn't match, clear the 'breadcrumb' key from local storage
    if($('body').hasClass('temp-product')){
    var get_html = $("span.product_breadcrumb").html();
    // Retrieve the stored HTML from local storagea
const breadcrumb = localStorage.getItem('breadcrumb');

// Check if the 'breadcrumb' is available
if (breadcrumb) {
    console.log(breadcrumb);  // Output: Stored HTML content
    // Use the 'breadcrumb' variable to insert or manipulate the HTML as needed
}
if(breadcrumb != null){
$(".breadcrumb").html(breadcrumb);
$(".breadcrumb").append(get_html);
}
    }else{
    localStorage.removeItem('breadcrumb');
    }
}


const url = window.location.href;
// Check if the URL contains '?variant='

var get_first_name = $(".get_first_option").val();
if (typeof get_first_name === "undefined") {
    // ...
}else{
var get_first_name_handle = get_first_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

}
var set_url = "?" + get_first_name_handle + "=";
if (url.includes(set_url)) {
  // Extract the variant value after '?variant='

  const variant = url.split(set_url)[1].split("&")[0];
var variant_name = variant.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
//  alert(variant_name);
   var get_len =  $(".option_name_cc").length;
      if(get_len == 2){
        var get_id = $(`.option_custom_variant .var_title[data-title=${variant_name}]`).attr('data-option1');
        var get_id2 = $(`.option_custom_variant .var_title[data-title=${variant_name}]`).attr('data-option2');
        $("input.option_name_cc").each(function(index){
       // alert(get_id2);
      if(index == 1){
     get_id = get_id2
      }
  //  alert(get_id);
    $("fieldset.js.product-form__input.product-form__input--pill").eq(index).find(`label.color_options[data-handle=${get_id}]`).trigger('click');
      //  $(`label.color_options[data-handle=${get_id}]`).trigger('click');

});

    }else{
     $(`label.color_options[data-handle=${variant_name}]`).trigger('click');
      }
}
$(".individual_head").click(function(){
var get_handle = $(this).attr('data-handle');
    $(".individual_head").removeClass('active');
    $(this).addClass('active');
    $("li.all_products").removeClass('active');
    $("li.all_products[data-handle="+get_handle+"]").addClass('active');
});
$('.custom_accordions .head').click(function(){
  $(this).toggleClass('active');
  $(this).parent().find('.arrow_wrap').toggleClass('arrow-animate');
  $(this).parent().find('.content').slideToggle(280);
});

var get_count = $("ul#product-grid li").length;
if(get_count > 1){
$("span#ProductCountDesktop").html(get_count + " products");
$("#ProductCountDesktop").show();
}else{
$("#ProductCountDesktop").show();
$("span#ProductCountDesktop").html(get_count + " product");
}
});
        $("details#Details-menu-drawer-container .header__icon[aria-label='Menu']").on("click",function() {
if($('body').hasClass('active_header') ){
if($('body').hasClass('overflow-hidden-tablet') ){
$("body").removeClass('active_header');

}else{
}
}
});
        $("details-modal.header__search").on("click",function() {
if($('body').hasClass('overflow-hidden-tablet')){
    $("details#Details-menu-drawer-container summary.header__icon.header__icon--menu.header__icon--summary.link.focus-inset").trigger('click');
$("body").addClass('active_header');

}
});
 let items_menus = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items_menus)
  items_menus.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });
$(".header__icon--search").click(function(){
$('body').toggleClass('active_header');
    
});
$(document).click(function (e) {
    if ($(e.target).parents(".header__search").length === 0 && $(e.target).parents(".header__icons").length === 0  ) {
         $("body").removeClass('active_header');
    }
});
$(".collapsible-content .accordion details summary").click(function(e){
e.preventDefault();
    e.stopPropagation();
    console.log('testt');
var $this = $(this).parent();
$(".collapsible-content .accordion details").removeAttr('open');
    $this.attr('open','');

if ($this.hasClass("active")) {
      $this.removeClass("active");
            $this.removeAttr('open')
      $this
        .siblings(".collapsible-content .accordion details")
       .removeAttr('open');
  
    } else {
     
     $this
        .siblings(".collapsible-content .accordion details")
       .removeAttr('open');
          $(".collapsible-content .accordion details").removeClass("active");

      $this.addClass("active");
   $this.attr('open','');
  
    }
    
});

  setTimeout(function() {
         $("body").removeClass('loader_hide');
            }, 2500);